<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.viewTags}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body">	
	<div *ngIf="!isready">
		<i>{{LOCALIZATION.unavailableTags}}</i>
	</div>
	<div *ngIf="isready" style="min-height:150px;max-height:600px;overflow-y:auto;overflow-x:hidden">
		<!-- // Left Panel (tag management) -->
		<div class="col-sm-6 col-md-6">
		        <div class="list-group-item" [hidden]="!relation.show">
		            <h4 class="list-group-item-heading">{{relation.label}}</h4>
		            <div style='margin-bottom:4px;' *ngIf='userPermissions["ROLE_PRODUCT_UPDATE"]'>
		                <div class="input-group">
							<!-- // Suggest implementation -->
							<!-- // Old
							<input 
								uib-typeahead="term for term in getSuggestions(relation.tagField, $viewValue)" 
								typeahead-min-length="1" 
								type="text" class='form-control'
								id="f_{{relation.name}}" data-ng-model="relation.value"
								placeholder="Enter a new Tag" aria-label="Tags input">
								-->
							<input 
							  [(ngModel)]="relation.value"
							  [ngbTypeahead]="search"
							  type="text" 
							  class="form-control suggestion-container"
							  id="f_{{relation.name}}" 
							  name="f_{{relation.name}}"
							  placeholder="Enter a new Tag" 
							  aria-label="Tags input" 
							/>
		                    <span class="input-group-btn">
		              			<button (click)='addTag()' class="btn btn-primary" type="button">{{LOCALIZATION.addTag}}</button>
		          			</span>
		                </div>
		            </div>
		            <div id='labelTank'>
		                <div *ngFor='let tag of tags' class='tagPartition'>
		            		<span class="tag label label-primary">
		              			<span class="link" (click)='searchTag(tag)' title="Find related documents with this tag">{{tag.name}}</span> 
								<a (click)='removeTag(tag)' *ngIf='userPermissions["ROLE_PRODUCT_UPDATE"]'>
								 	<i class="remove fa fa-times text-white"></i>
								</a>
		           			</span>
		                </div>
		            </div>
		        </div>				
        </div>
        <!-- // Right Panel (tag search and view) -->
		<div class="col-sm-6 col-md-6">
	        <div class="list-group-item">
	            <h4 class="list-group-item-heading">{{LOCALIZATION.relatedDocuments}}</h4>	            
	            <div id='labelTank'>
					<div>Select a tag to show related documents here.</div>
          	    	<div [hidden]="!loading">
              	  		<i class="fas fa-spinner fa-spin fa-fw"></i>
             	 		{{LOCALIZATION.loading}}
                	</div> 					
	                <div *ngFor='let relation of tagSearch.related' class="relationship">
	            		<span class="label label-primary" *ngIf='!relation.tagremoved'>
	              			<span class="link pointMe" (click)='searchRelated(tagSearch.relation)'>{{relation.title}}</span> 							
	           			</span>
	                </div>					
	            </div>
	        </div>
        </div>        
	</div>                    
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
    <button [hidden]="!isready" class="btn btn-primary" type="button" (click)="save()">{{LOCALIZATION.save}}</button>
</div>
